import React, { useState }from 'react';
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'

const AlertDismissible = () => {
    const [show, setShow] = useState(false);
  
    if (show) {
      return (
        <Alert variant="success" onClose={() => setShow(false)} dismissible>
          <Alert.Heading>Some Notes</Alert.Heading>
          <p className="mb-0">
            Welcome to the clocking system site! This is a deployed version of the <a href="https://medium.com/create-a-clocking-in-system-on-react">publication</a> on Medium. The code has been tweaked a tiny bit compared to the original. Namely:
            <br/>
            <br/>- This is a deployed version, so the URL that we normally access the data from is changed.
            <br/>
            <br/>- The staff members added are capped at 5 people to stop the naughty people overloading my backend, you can still add new staff and be able to see them, however, the older staff will be deleted to fit the newbies in. 
            <br/>
            <br/>- A few CSS tweaks to make everything including this note fit well and look nice, this includes replacing the img tag with an SVG instead as well as some other undisclosed <i>things</i>
          </p>

          <p>  
            <hr />
            Let me know what you think of this site in the comments on Medium! 
            <br/> Also, go crazy & leave your mark in history by submitting a staff name (not really though, it's gonna be deleted eventually)
          </p>
        </Alert>
      );
    }
    return <Button id="psst" onClick={() => setShow(true)}><p>👉 Pssst, click me 👈</p> </Button>;
}
  
export default AlertDismissible;